module.exports = __webpack_public_path__ + "img/Flag_of_Antigua_and_Barbuda.ef092ac5.svg";